<div class="flex" [ngClass]="{
    'flex-col': $isMobile(),
    'flex-row items-end': !$isMobile()
    }">

    @if ($calendarOptions(); as options) {
        <full-calendar #calendar [events]="$calendarEvents()" [options]="options" class="h-full w-full">
            <ng-template #eventContent let-arg>
                @switch (arg.view.type) {
                    @case (getCalendarViewFromLabel('listLabel')) {
                        <div class="flex flex-row gap-2">
                            <button (click)="clickOnEvent(arg)" type="button" class="inline-flex items-center gap-3 hover:underline">
                                <p class="font-bold">{{ arg.event.title }}</p>
                            </button>
                        </div>
                    }
                    @case (getCalendarViewFromLabel('monthLabel')) {
                            <div (click)="clickOnEvent(arg)" class="flex flex-row gap-1 items-center overflow-hidden">
                                <div class="border-8 rounded-full box-content h-0 w-0" [ngStyle]="{'border-color': arg.event.backgroundColor}"></div>
                                <div class="flex flex-row">{{ arg.event.start | date: 'HH:mm' }}</div>
                                <div class="font-bold overflow-hidden text-ellipsis whitespace-nowrap">
                                    {{ arg.event.title }}
                                </div>
                            </div>
                    }
                    @default {
                        <div class="h-full" (click)="clickOnEvent(arg)">
                            @switch (getEventDurationCategory(arg)) {
                                @case ('long') {
                                    <div class="flex flex-row gap-1 items-center overflow-hidden">
                                        <div class="font-bold">
                                            {{ arg.event.title }}
                                        </div>
                                    </div>
                                    <div class="flex flex-row">
                                        @if (arg.event.end) {
                                            {{ arg.event.start | date: 'HH:mm' }} - {{ arg.event.end | date: 'HH:mm' }}
                                        } @else {
                                            {{ arg.event.start | date: 'HH:mm' }}
                                        }
                                    </div>
                                }
                                @case ('short') {
                                    <div class="flex flex-row gap-1 items-center overflow-hidden">
                                        <div class="font-bold fixed-ellipsis">
                                            ...
                                        </div>
                                    </div>
                                }
                                @default {
                                    <div class="flex flex-row gap-1 items-center overflow-hidden">
                                        <div class="font-bold">
                                            {{ arg.event.title }}
                                        </div>
                                    </div>
                                }
                            }
                        </div>
                    }
                }
            </ng-template>
        </full-calendar>
    }
</div>


<ng-template #eventTemplate>
    @if ($selectedEvent(); as event) {
        <div class="first:pt-1 pb-3 mb-3 flex flex-col gap-4 border-b border-b-gray">
            <div class="flex flex-row gap-2 items-center overflow-hidden">
                <div class="border-8 rounded-full box-content h-0 w-0" [ngStyle]="{'border-color': event.color}"></div>
                <div class="font-bold overflow-hidden text-ellipsis whitespace-nowrap">
                    {{ event.title }}
                </div>
            </div>

            <div class="flex flex-col gap-4 items-start">
                <div class="flex flex-col gap-2">
                    <div class="flex items-stretch justify-start gap-x-2">
                        <meta-icon icon="calendar"></meta-icon>
                        <p class="inline-block font-semibold">{{event.date}}</p>
                        @if (!event.inProgress && event.passed) {
                            @if (!event.rec) {
                                <p class="inline-block font-semibold text-primary">{{'Event concluded' | translate}}</p>
                            }
                        } @else if (!event.inProgress && event.future) {
                            <p class="inline-block font-semibold text-secondary">{{'Event scheduled' | translate}}</p>
                        }
                    </div>

                    @if(!event.passed) {
                        <div class="flex items-center justify-start gap-4">
                            @if(event.dateStart) {
                                <div class="flex gap-2">
                                    <p class="inline-block font-semibold text-primary">{{'Start time' | translate}}:</p>
                                    <p class="inline-block">{{event.dateStart | date: 'HH:mm'}}</p>
                                </div>
                            }
                            @if(event.dateEnd) {
                                <div class="flex gap-2">
                                    <p class="inline-block font-semibold text-primary">{{'End time' | translate}}:</p>
                                    <p class="inline-block">{{event.dateEnd | date: 'HH:mm'}}</p>
                                </div>
                            }
                        </div>
                    }
                </div>

                @if (event.description; as description) {
                    <div>
                        <p>{{description}}</p>
                    </div>
                }

                @if (event.passed) {
                    @if (event.rec) {
                        <a class="btn btn-primary h-10 items-center justify-center rounded-md px-6 py-2 cursor-pointer" [href]="event.rec" target="_blank">{{'View recording' | translate}}</a>
                    }
                } @else {
                    @if (event.url) {
                        <a class="btn btn-primary h-10 items-center justify-center rounded-md px-6 py-2 cursor-pointer" [href]="event.url" target="_blank" (click)="onParticipateClick($event)">{{'Participate' | translate}}</a>
                      }
                }
            </div>

        </div>
        @if (event.courseId) {
            @if ($selectedEventCourse()) {
                <div  class="flex flex-col items-start gap-4 *:max-w-full">
                    <p class="inline-block text-lg font-semibold text-primary">{{"Associated course" | translate}}</p>
                    <meta-course-preview [course]="$selectedEventCourse()!" [title]="$selectedEventCourse()!.title"
                        [lowerHeight]="coursesPreviewConfig.lowerHeight ?? false"
                        [showProgress]="coursesPreviewConfig.showProgress ?? false"
                        [showStudents]="coursesPreviewConfig.showStudents ?? false"
                        [showSkills]="coursesPreviewConfig.showSkills ?? false"
                        [showImage]="coursesPreviewConfig.showImage ?? false"
                        [showDescription]="coursesPreviewConfig.showDescription ?? false"
                        [showContentTypeIcon]="coursesPreviewConfig.showContentTypeIcon ?? false"
                        [showStarIcon]="(coursesPreviewConfig.showStarIcon ?? false) && ($selectedEventCourse()!.associatedToUser || false)"
                        [showLockIcon]="!!$selectedEventCourse()!.toBuy && !$selectedEventCourse()!.associatedToUser"
                        (doClick)="$courseToPreview.set($selectedEventCourse())"
                        class="cursor-pointer !block !h-auto" />
                </div>
            }
        }
    }
</ng-template>

<ng-template #filtersTemplate>
    <div class="flex flex-col gap-4">
        @if ($searchViewGroup() && $isMobile()) {
            <label for="inputMobileViewsList">{{'Type of calendar view' | translate}}</label>
            <meta-dropdown id="inputMobileViewsList" [config]="{ hideDefaultValue: true, style: { border: true, hostFullWidth: true, } }"
                [options]="$searchViewGroup()?.values"
                [selectedValue]="$searchViewGroup()?.selectedValue" (optionSelected)="updateCalendarView($event)"/>
        }
        @if ($searchFilterGroup()) {
            <label for="searchFilterGroup">{{'Courses' | translate}}</label>
            <meta-dropdown id="searchFilterGroup" [config]="{ emptyLabel: $searchFilterGroup()?.label ?? '' | translate, style: { border: true, hostFullWidth: true, } }"
                [options]="$searchFilterGroup()?.values"
                [selectedValue]="$searchFilterGroup()?.selectedValue" (optionSelected)="updateActiveFilters($event)"/>
        }
        @if (showFilterByMyCourses) {
            <div class="inline-flex items-center gap-1 select-none">
                <input id="filterByMyCourses" (click)="toggleShowMyCourses()" type="checkbox">
                <label for="filterByMyCourses" class="hover:underline">{{'My courses' | translate}}</label>
            </div>
        }
    </div>
</ng-template>

<ng-template #eventIsScheduledModalTemplate>
    <div class="">
        {{'Event is scheduled alert' | translate: {
        date: (this.$selectedEvent()?.dateStart) | date:'shortDate',
        time: (this.$selectedEvent()?.dateStart) | date:'shortTime'
        } }}
    </div>
</ng-template>

<ng-template #eventIsStartingModalTemplate>
    <div class="flex flex-col gap-6">
        <div>
          {{'Event is starting soon' | translate }}:
        </div>
        <div class="self-end">
            <a class="btn btn-primary h-10 items-center justify-center rounded-md px-6 py-2 cursor-pointer" [href]="$selectedEvent()!.url" target="_blank" (click)="onParticipateClick($event, true)">{{'Participate' | translate}}</a>
        </div>
    </div>
</ng-template>

@defer (when $courseToPreview()) {
    @if ($courseToPreview()) {
        <meta-modal class="courseDetails fixed z-1002"
            (doClose)="$courseToPreview.set(undefined)" [settings]="{contentWide: true, closable: true, closeOnEscape: true}">
            <meta-course-detail modal-content [course]="$courseToPreview()!" [needActivation]="!$courseToPreview()!.status"
                (openCourse)="startCourse($courseToPreview()!, $event)" (updateData)="updateCourseToPreview($event)" />
        </meta-modal>
    }
}
